<template>
  <el-dialog
    v-model="dialogVisible"
    title=""
    width="380"
    :append-to-body="true"
    :destroy-on-close="true"
    :align-center="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeDial"
  >
    <div style="min-height: 78px;position: relative;">
      <div v-if="!networkErr" v-loading="!networkErr" element-loading-text="Google Recaptcha Loading..." class="recap-loading-wrap"></div>
      <div v-else class="recap-mid net-err">Network load failed. Please check your connection or try again later.</div>
      <div style="position: relative;z-index: 2002;padding-left: 14px;">
        <vue-recaptcha ref="recaptcha0" :sitekey="reSiteKey" language="en" loadRecaptchaScript="false" 
          @verify="verifyMethod"
          @expired="expiredMethod"
          @render="renderMethod"
          @error="errorMethod"
        >
        </vue-recaptcha>
      </div>
    </div>
    <template #footer></template>
  </el-dialog>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import config from '../config';

export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      timerRef: null,
      networkErr: false,
      dialogVisible: true,
      response: '',
      reSiteKey: config.reSiteKey.join(''),
    };
  },
  created() {
    if (this.timerRef) {
      clearTimeout(this.timerRef)
      this.timerRef = null
    }
    this.timerRef = setTimeout(() => {
      this.networkErr = true
      this.timerRef = null
    }, 35000)
  },
  methods: {
    closeDial() {
      this.dialogVisible = false
      this.$emit('closeDialog')
    },
    verifyMethod(response) {
      // console.log(response)
      this.response = response || ''
      this.$emit('changeResponse', this.response)
    },
    expiredMethod() {
      console.log('expired()')
      this.$refs.recaptcha0.reset();
    },
    renderMethod(id) {
      console.log(id)
    },
    errorMethod() {
      console.log('error()')
    },
  },
};
</script>

<style>
  .recap-loading-wrap {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  .recap-loading-wrap .el-loading-spinner {
    transform: translateY(-10px);
  }
  .recap-mid {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .net-err {
    width: 80%;
    color: rgba(16, 16, 16, 0.6);
  }
</style>
